export class CamDataValidation {

  constructor(
    public affectedSchedulerTasks: String[],
    public updatable: boolean
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/cam-data-validation.ts